module.exports = __webpack_public_path__ + "static/media/train11-3.73ad721a.png";